module.exports = __webpack_public_path__ + "static/06-1-4877014eb6e129e8583837b897e62c95.jpg";